import React from "react";

export const en = {
  body: (
    <div>
      <h3>JUICE</h3>
      The JUICE program (
      <a href="https://www.sci.muni.cz/botany/juice/">https://www.sci.muni.cz/botany/juice/</a>) is
      a widely used non-commercial software package for editing and analysing vegetation-plot data.
      It was written by Lubomír Tichý in the Vegetation Science Group in 1998, and it is
      continuously updated since then. Various options include classifications by divisive and
      agglomerative methods and by expert systems, identification of diagnostic species using
      fidelity measures, automatic sorting of vegetation-plot tables, preparation of synoptic
      tables, calculating site-mean indicator values, and export of analysed data into different
      formats.
    
	<p>
        <cite>
          Tichý L. (2002): JUICE - software for vegetation classification. Journal of Vegetation Science 13: 451–453. – {" "}
            <a target="_blanc" href="https://onlinelibrary.wiley.com/doi/10.1111/j.1654-1103.2002.tb02069.x">fulltext in Wiley Online Library</a>
        </cite>
	</p>
      </div>
  )
};

export const cz = {
  body: (
    <div>
      <h3>JUICE</h3>
      Program JUICE (
      <a href="https://www.sci.muni.cz/botany/juice/">https://www.sci.muni.cz/botany/juice/</a>) je
      široce používaný nekomerční software pro editaci a analýzu vegetačních dat. Napsal jej Lubomír
      Tichý z pracovní skupiny Výzkum vegetace v roce 1998 a od té doby jej průběžně aktualizuje.
      Mezi různé analytické možnosti patří klasifikace divizivními a aglomerativními metodami a
      expertními systémy, určování diagnostických druhů pomocí indexů fidelity, automatické třídění
      fytocenologických tabulek, příprava synoptických tabulek, výpočet průměrných indikačních
      hodnot pro snímky a export analyzovaných dat do různých formátů.
    <p>
        Doporučená citace programu JUICE: <br />
        <cite>
          Tichý L. (2002): JUICE - software for vegetation classification. Journal of Vegetation Science 13: 451–453. – {" "}
            <a target="_blanc" href="https://onlinelibrary.wiley.com/doi/10.1111/j.1654-1103.2002.tb02069.x">fulltext na Wiley Online Library</a>
        </cite>
	</p>
	</div>
  )
};
